<template>
  <v-list>
    <v-subheader class="d-flex flex-row">
      <v-divider/>
      <div class="mx-3">
        {{title}}
      </div>
     <v-divider/>
    </v-subheader>
    <template v-for="(dean, i) in errorMessages">
      <v-list-item  :key="`${i} - ${dean}`" dense>
        <v-list-item-icon>
          <v-icon small color="error">
            fa fa-info-circle
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="text-wrap" v-html="dean"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider :key="i" v-if="i < errorMessages.length - 1"/>
    </template>
  </v-list>
</template>

<script>
export default {
  name: "error-message",
  props: {
    errorMessages: {
      Type: Array,
      require: true
    },
    title: {
      Type: String,
      require: true,
    }
  }
}
</script>

<style scoped>

</style>